export default "__VITE_ASSET__CMAxL6mP__"